/*
 * @Author: your name
 * @Date: 2021-06-16 11:21:43
 * @LastEditTime: 2021-07-20 09:51:32
 * @LastEditors: Enzo
 * @Description: In User Settings Edit
 * @FilePath: /waimai_cd_fe_greentech_c/src/assets/apis/scientist.js
 */
import { get, post, axios } from '../../utils/http';

// 青年科学家详情查询接口
export const getProjectInfo = (data) => get('/project/detail', data);
// 青年科学家详情查询接口评委
export const getProjectByNo = (data) => get('/scientist/getProjectInfoByNo', data);
// 青年科学家提名码查询
export const getNominator = (data) => get('scientist/getNominator', { codes: data });

// 青年科学家基础信息保存接口
export const savePersonInfo = (data) => post('/scientist/savePersonInfoV2', data);
// 青年科学家科研信息保存接口
export const saveStudyInfo = (data) => post('/scientist/saveStudyInfoV2', data);

// 青年科学家申报信息保存接口
export const saveApplyInfo = (data) => post('/scientist/saveApplyInfo', data);

// 青年科学家提交接口
export const submitScientist = (data) => axios.post('/scientist/submitRecord', data);

// 学校模糊查询
export const querySchool = (data) => get('/dict/querySchool', data);

// 科研议题
export const getTecTopic = (data) => get('/dict/getAllTopic', data);
// 学科领域
export const getSubject = (data) => get('/dict/getAllSubjectArea', data);
// 专业模糊查询

export const queryMajor = (data) => get('/dict/queryMajor', data);

//个人科研成就、进展及规划模板
export const getTemplateFileUrl = (data) => get('file/getTemplateFileUrl', data);
